module.exports = __webpack_public_path__ + "static/img/logo-lube.56fda2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-lube.png
// module id = BSQo
// module chunks = 0